module.exports = __webpack_public_path__ + "static/media/37.1544b51b.jpg";